module.exports = __webpack_public_path__ + "img/han-image-box.24b425d8.jpg";